import React, { useState } from 'react';
import FeedbackModal from './FeedbackModal';
import '../../styles/components/FeedbackButton.css'; // Assumes CSS was created

const FeedbackButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <button onClick={toggleModal} className="feedback-fab" title="Leave Feedback">
        Feedback
      </button>
      {isModalOpen && <FeedbackModal onClose={toggleModal} />}
    </>
  );
};

export default FeedbackButton;
